import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import MapComponent from '@/components/MapComponent';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const MapItem = ({
  markerCoordinates,
  markerTitle,
  markerDescription
}: {
  markerCoordinates: number[] | undefined | null;
  markerTitle: string;
  markerDescription: string;
}) => {
  const colors = useColor();
  const latitude = markerCoordinates?.at(0) ?? 0;
  const longitude = markerCoordinates?.at(1) ?? 0;
  return (
    <View style={styles.flexOne}>
      <View style={styles.titleContainer}>
        <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
          {i18n.t('npo_details.insights.map')}
        </Text>
      </View>
      <View style={styles.content}>
        {markerCoordinates && markerCoordinates.length > 0 ? (
          <MapComponent
            initialRegion={{
              latitude: latitude,
              longitude: longitude,
              latitudeDelta: 0.0922,
              longitudeDelta: 0.0421
            }}
            markerCoordinates={[latitude, longitude]}
            markerTitle={markerTitle}
            markerDescription={markerDescription}
          />
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default MapItem;

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  map: {
    width: '100%',
    height: 300
  }
});
